import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgResqPartnership = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "resq-partnership" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5.25,
			cy: 13.5,
			r: 2.25
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 18.75,
			cy: 13.5,
			r: 2.25
		}),
		/* @__PURE__ */ _jsx("path", { d: "M1.5 21v-1.5a3.75 3.75 0 0 1 7.5 0V21h6v-1.5a3.75 3.75 0 0 1 7.5 0V21" }),
		/* @__PURE__ */ _jsx("path", { d: "M8.25 9V6.75M12 9V4.5M15.75 9V2.25" })
	]
});
export default SvgResqPartnership;
